document.addEventListener('DOMContentLoaded', function() {
  const galleryList = document.getElementById('upfit-gallery-list');
  const galleryButton = document.querySelector('.upfit-gallery-button');

  if (galleryButton) {
    if (!galleryList || galleryList.children.length === 0) {
      galleryButton.style.display = 'none';
    }
  }

  const expandBtn = document.getElementById('upfit-gallery-expand-btn');

  if (!expandBtn) return;

  let isExpanded = false;

  expandBtn.addEventListener('click', function() {
    const allItems = document.querySelectorAll('.gallery-item');
    const galleryWrap = document.querySelector('.upfit-gallery-wrap');

    if (!isExpanded) {
      allItems.forEach(item => {
        item.classList.remove('gallery-item--hidden');
      });
      this.textContent = 'View Less Customer Submissions';
      isExpanded = true;
    } else {
      allItems.forEach((item, index) => {
        if (index >= 10) {
          item.classList.add('gallery-item--hidden');
        }
      });
      this.textContent = 'View More Customer Submissions';
      isExpanded = false;

      if (galleryWrap) {
        galleryWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });
});
